import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import { Figure, StyledFigcaption } from "scmp-app/components/content/content-cover-image/styles";
import {
  Flag,
  FlagDivider,
} from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import { SponsorHeadline } from "scmp-app/components/content/content-headline/styles";
import { LiveTag } from "scmp-app/components/content/content-live-tag/styles";
import { StyledTopicLink } from "scmp-app/components/content/content-topic-link/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  position: relative;

  display: grid;

  color: #000000;
`;

export const Header = styled.div`
  grid-area: header;

  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;

  margin-block-end: 8px;

  :empty {
    display: none;

    margin: 0;
  }
`;

export const LiveTagContainer = styled.div`
  ${LiveTag} {
    gap: 4px;

    block-size: auto;
    padding: 0;

    color: #eb4254;
    font-weight: 700;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    line-height: normal;

    background-color: transparent;

    &:before {
      inline-size: 10px;
      block-size: 10px;

      background-color: #eb4254;
    }
  }
`;

export const TopicLabel = styled.div`
  ${StyledTopicLink} {
    color: #4585ff;
    font-weight: 700;
    font-size: 13px;
    font-family: ${fontRobotoCondensed};
    text-transform: uppercase;
  }
`;

export const PlusTag = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  padding-block: 0;
  padding-inline: 2px;

  color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;

  border-radius: 2px;

  background-color: #4585ff;
`;

export const Headline = styled.div`
  grid-area: headline;

  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  align-items: flex-start;

  font-weight: 600;
  font-size: 16px;
  font-family: ${fontSourceSerif4};
  line-height: 130%;
  letter-spacing: -0.32px;

  ${SponsorHeadline} {
    font-weight: 700;
    line-height: 140%;
  }

  ${Flag} {
    font-style: italic;
  }

  ${FlagDivider} {
    color: #000000;
    font-style: normal;
  }
`;

export const Summary = styled.div`
  grid-area: summary;

  margin-block-start: 8px;

  color: #5a5a5a;
  font-weight: 500;
  font-family: ${fontSourceSerif4};

  && {
    font-size: 14px;
    line-height: 135%;
    letter-spacing: -0.14px;
  }

  &:empty {
    display: none;

    margin: 0;
  }
`;

export const SubHeadline = styled.div`
  grid-area: subHeadline;

  margin-block-start: 8px;

  color: #6f6f6f;
  font-size: 14px;
  line-height: 130%;

  &:empty {
    display: none;

    margin: 0;
  }
`;

export const ActionBar = styled.div`
  grid-area: action-bar;

  margin-block-start: 12px;

  time {
    color: #999999;
    font-weight: 400;
    font-size: 11px;
    font-family: ${fontRoboto};
    line-height: 100%;
  }
`;

export const SponsorTagContainer = styled.div`
  grid-area: action-bar;

  max-inline-size: 240px;
  margin-block-start: 12px;
`;

export const CoverImage = styled.div`
  grid-area: cover-image;

  inline-size: 100%;
  block-size: auto;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }

  ${Figure} picture {
    aspect-ratio: 3 / 2;

    img {
      aspect-ratio: inherit;
    }
  }

  ${StyledFigcaption} {
    ${theme.breakpoints.up("tablet")} {
      line-height: 14px;
    }
  }
`;

export const Container = styled.div`
  display: grid;
  grid:
    "header" min-content
    "headline" min-content
    "subHeadline" min-content
    "summary" min-content
    "action-bar" min-content
    "cover-image" min-content
    / 100%;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "header cover-image" min-content
      "headline cover-image" min-content
      "subHeadline cover-image" min-content
      "summary cover-image" min-content
      "action-bar cover-image" min-content
      ". cover-image" minmax(0, 1fr)
      / 0.5fr 0.5fr;
    column-gap: 20px;
  }

  :not(:has(${CoverImage})) {
    grid-template-columns: 1fr 0fr;
    column-gap: 0;
  }
`;
